import React from "react";
import {useLocation} from "react-router-dom";
import ListItem from "@/components/ListItem";

export default function List({
         currentLocation,
         points,
         onItemClick
     }) {

    const location = useLocation();

    // Track page view
    React.useEffect(() => {
        var _paq = window._paq = window._paq || [];
        _paq.push(['setCustomUrl', location.pathname]);
        _paq.push(['setDocumentTitle', 'Points - List']);
        _paq.push(['trackPageView']);
    }, [location])

    return (
        <div className={`mt-2`}>
            {Object.entries(points)
                .sort(([, a], [, b]) => a.data.order - b.data.order)
                .map(([pointId, point]) => (
                <ListItem key={pointId} pointId={pointId} point={point} onClick={onItemClick}/>
            ))}
        </div>
    );
}
